var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(!_vm.hidden)?_c('div',{staticClass:"vuestic-alert alert",class:_vm.alertClass},[_vm._t("default"),_vm._v(" "),(_vm.withCloseBtn)?_c('i',{staticClass:"fa fa-close alert-close",on:{"click":function($event){_vm.hide()}}}):_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18293c8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vuestic-components/vuestic-alert/VuesticAlert.vue
// module id = EP4V
// module chunks = 114